//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmIcon from '~/components/atoms/Global/MdmIcon';
import MdmVideoSrcset from '~/components/atoms/Global/MdmVideoSrcset';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/play.svg';
var RATIOS = {
  '16:9': 'ri-16_9',
  '100:41': 'ri-41',
  '13:3': 'ri-23',
  '9:16': 'ri-9_16',
  '8:3': 'ri-38',
  '4:3': 'ri-4_3',
  '3:4': 'ri-3_4',
  '10:3': 'ri-10_3',
  '1:1': ''
};
export default {
  name: 'RegularMedia',
  components: {
    MdmIcon,
    MdmVideoSrcset
  },
  props: {
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    videoMp4: {
      type: [String, Object],
      default: ''
    },
    videoWebm: {
      type: [String, Object],
      default: ''
    },
    ratioImg: {
      type: String,
      default: '16:9'
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
    playColor: {
      type: String,
      default: 'white'
    },
    muted: {
      type: Boolean,
      default: true
    },
    withVideoSrcset: {
      type: Boolean,
      default: false
    },
    videoImages: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      isPaused: !this.autoPlay
    };
  },

  computed: {
    builderRatio() {
      return RATIOS[this.ratioImg];
    }

  },
  methods: {
    toggleVideo(evt) {
      var video = evt.target;

      if (video.paused) {
        video.play();
        this.isPaused = false;
      } else {
        video.pause();
        this.isPaused = true;
      }
    }

  }
};